// extracted by mini-css-extract-plugin
export default {"watermark":"index_watermark_j12Fw"};